import React, { Component } from 'react';
import serverClientUtil from '../../../utils/serverClientUtil';
import { heartIcon } from './svgIcons';

class WishList extends Component {
  render() {
    const { hasActiveSession } = this.props;
    const urlEcom = serverClientUtil.getLPURL();
    const redirectUrl = hasActiveSession ?
      `https:${urlEcom}/tienda/users/wishlist` :
      `https:${urlEcom}/tienda/login?redirectAfterLoginHref=https:${urlEcom}/tienda/users/wishlist`;
    return (
      <React.Fragment>
        <a
          href={redirectUrl}
          className="heartIcon"
        >
          {heartIcon}
        </a>
      </React.Fragment>
    );
  }
}

export default WishList;
